export default __webpack_public_path__ + "static/media/IBAT.c624689d.png";